import React from "react";
import FaqList from "./FaqList";

const FaqAccordion = ({ faq }) => {
  return (
    <div>
      {faq?.map((item, index) => {
        return (
          <FaqList
            question={item?.question}
            answer={item?.answer}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default FaqAccordion;
